import { defineComponent as _defineComponent } from 'vue'
import ArrayInput from '@/components/base/ArrayInput.vue';
import Reflection from '@/components/exercise/Content/Reflection.vue';
import OpenEndedQuestion from '@/components/exercise/Content/OpenEndedQuestion.vue';
import ExternalReference from '@/components/exercise/Content/ExternalReference.vue';
import CloseEndedQuestion from '@/components/exercise/Content/CloseEndedQuestion.vue';
import { ref } from 'vue';
import {
  Instruction as InstructionType,
  OpenEndedQuestion as OpenEndedType,
  ExternalReference as ExternalReferenceType,
  CloseEndedQuestion as CloseEndedQuestionType,
  Content,
} from '@ilteducation/exercise-service-types';


export default /*#__PURE__*/_defineComponent({
  __name: 'EditContent',
  setup(__props) {

const arrayInputRef = ref();

const contentTypes: { value: Content['type']; text: string; default: Omit<Content, 'type'> }[] = [
  {
    value: 'open-question',
    text: 'Open ended question',
    default: <Omit<OpenEndedType, 'type'>>{ phrase: '', answer: '' },
  },
  {
    value: 'closed-question',
    text: 'Close ended question',
    default: <Omit<CloseEndedQuestionType, 'type'>>{ phrase: '', options: [], answer: '' },
  },
  {
    value: 'external-reference',
    text: 'External reference',
    default: <Omit<ExternalReferenceType, 'type'>>{ text: '', url: '' },
  },
  {
    value: 'reflection-task',
    text: 'Reflection task',
    default: <Omit<InstructionType, 'type'>>{ title: '', description: '' },
  },
];
const defaultContent = (type: Content['type']) => contentTypes.find((ct) => ct.value === type)?.default;

const selected = (newContent: {
  index: number;
  item: Content | Pick<Content, 'id' | 'type'>;
  parentSource: string;
  resource: string;
}) => {
  if (Object.keys(newContent.item).length === 2) {
    arrayInputRef.value.replace(newContent.index, {
      ...newContent.item,
      ...defaultContent(newContent.item.type),
    });
  }
};

const hidden = ref<number[]>([]);
const toggle = (index: number) => {
  if (hidden.value.includes(index)) {
    hidden.value.splice(hidden.value.indexOf(index), 1);
  } else {
    hidden.value.push(index);
  }
};

return { __sfc: true,arrayInputRef, contentTypes, defaultContent, selected, hidden, toggle, ArrayInput, Reflection, OpenEndedQuestion, ExternalReference, CloseEndedQuestion }
}

})